import type { BookingSchema, CreateBookingDtoSchema, UpdateBookingDtoSchema } from "@nexttrack/api-schema";

import { rootApi } from "@/store/services/root-api";

export const bookingsApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getBookings: builder.query<BookingSchema[], { individualId?: string; projectId?: string } | void>({
            query: (params) => ({ url: "bookings", params: params ?? {} }),
            providesTags: ["Booking"],
        }),
        createBooking: builder.mutation<BookingSchema, CreateBookingDtoSchema>({
            query: (body) => ({ url: "bookings", method: "POST", body }),
            invalidatesTags: ["Booking", "Timeline", "Project"],
        }),
        updateBooking: builder.mutation<BookingSchema, { id: string; data: UpdateBookingDtoSchema }>({
            query: ({ id, data }) => ({ url: `bookings/${id}`, method: "PATCH", body: data }),
            invalidatesTags: ["Booking", "Timeline", "Project"],
        }),
        deleteBooking: builder.mutation<void, string>({
            query: (id) => ({ url: `bookings/${id}`, method: "DELETE" }),
            invalidatesTags: ["Booking", "Timeline", "Project"],
        }),
    }),
});

export const { useGetBookingsQuery, useCreateBookingMutation, useUpdateBookingMutation, useDeleteBookingMutation } =
    bookingsApi;
